import { useState, useCallback, useMemo, useRef, useContext } from 'react';
import {Box,Grid, TextField, Typography, Button, Container, Slider, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, DialogActions} from '@mui/material';
import { Add,} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'
import { callPostApi } from '../../function/ApiCallFunction';
import InfoPopover from '../../components/CommanComponents/InfoPopover';
import GradientLoader from '../../components/CommanComponents/GradientLoader';
import DialogBox from '../../components/ajax/DialogBox';
import { callShopviewPostApi } from '../../function/ApiCallFunction';
import { DataContext } from '../../context/DataContext';

export default function CreateCouponDialog() 
{
    const {loginData,setLoginData }  = useContext(DataContext);
    const store_id      = loginData?.store_info?.store_id;

  const [opend, setOpend] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const inputRef1 = useRef(null);
  const [imageFile, setImageFile] = useState('');
  const [imagePreview, setImagePreview] = useState(null);  
  const [distributionBid, setDistributionBid] = useState(5);
  // const [redemptionBid, setRedemptionBid] = useState(15);
  const [offerId, setOfferId] = useState(false);
  const today = new Date();
  const sixMonthsLater = new Date();
  sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6);
  const formattedToday = today.toISOString().split('T')[0];
  const formattedSixMonthsLater = sixMonthsLater.toISOString().split('T')[0];
  const [formData, setFormData] = useState({ offerTitle: '', couponValue: '', minAmount: '', maxAmount: '', shortDesc: '',
  longDesc: '', dateStart: formattedToday, dateEnd: formattedSixMonthsLater,  valueType: 'fixed', });
  const [errors, setErrors] = useState({});
  const shortDescMaxLength = 150;
  const longDescMaxLength = 500;
 
  // Memoized slider marks
  const marks = useMemo(() => [
    { value: 5, label: '5₹' }, { value: 10, label: '10₹' },
    { value: 15, label: '15₹' }, { value: 20, label: '20₹' },
    { value: 25, label: '25₹' }, { value: 30, label: '30₹' },
  ], []);

  // const marks1 = useMemo(() => [
  //   { value: 15, label: '15₹' }, { value: 20, label: '20₹' },
  //   { value: 25, label: '25₹' }, { value: 30, label: '30₹' },
  //   { value: 35, label: '35₹' }, { value: 40, label: '40₹' },
  //   { value: 45, label: '45₹' }, { value: 50, label: '50₹' },
  // ], []);

  // Handlers
  const updateField = useCallback((field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    setErrors(prev => ({ ...prev, [field]: '' }));
  }, []);
    

    // const validateImage = (file) => 
    // {
    //     const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    //     const maxSize = 1 * 1024 * 1024; 

    //     if (!allowedTypes.includes(file.type)) {
    //         setErrors(prev => ({ ...prev, proCivilImage: 'Only JPEG, PNG, and JPG formats are allowed.' }));
    //         return false;
    //     }

    //     if (file.size > maxSize) {
    //         setErrors(prev => ({ ...prev, proCivilImage: 'Image size should be less than 1MB.' }));
    //         return false;
    //     }

    //     setErrors(prev => ({ ...prev, proCivilImage: '' }));
    //     return true;
    // };

// inside handleSubmit
const handleSubmit = async () =>  {
  const tempErrors = {};

  if (!formData.offerTitle.trim()) tempErrors.offerTitle = 'Coupon title is required';
  if (!formData.dateStart) tempErrors.dateStart = 'Active date is required';
  
  if (!formData.dateEnd) tempErrors.dateEnd = 'Expiry date is required';

  if (!formData.shortDesc.trim()) tempErrors.shortDesc = 'Short description is required';
  if (formData.shortDesc.length > shortDescMaxLength) tempErrors.shortDesc = `Short description cannot exceed ${shortDescMaxLength} characters`;

  if (!formData.longDesc.trim()) tempErrors.longDesc = 'Long description is required';
  if (formData.longDesc.length > longDescMaxLength) tempErrors.longDesc = `Long description cannot exceed ${longDescMaxLength} characters`;

  if (!formData.minAmount) {
    tempErrors.minAmount = 'Minimum order amount is required';
  } else if (Number(formData.minAmount) < 100) {
    tempErrors.minAmount = 'Minimum order value must be at least ₹100';
  }

  if (!formData.maxAmount || Number(formData.maxAmount) <= 0) {
    tempErrors.maxAmount = 'Number of coupons is required';
  }
  if (!formData.couponValue || Number(formData.couponValue) <= 0) {
    tempErrors.couponValue = 'Coupon value is required';
  }
  if (!distributionBid) {
    tempErrors.distributionBid = 'Distribution Bid is required';
  }
  // if (!redemptionBid) {
  //   tempErrors.redemptionBid = 'Redemption Bid is required';
  // }

  setErrors(tempErrors);
  if (Object.keys(tempErrors).length > 0) return;
  try { setLoading(true);
    const payload = { mod: "ADD_CASHI_OFFER", data_arr: { store_id, offer_title: formData.offerTitle, 
        short_desc: formData.shortDesc, long_desc: formData.longDesc, coupon_coin: formData.couponValue, max_coupon: formData.maxAmount,  
        min_order_amount: formData.minAmount, distribution_bid: distributionBid,redemption_bid: "0", 
        coupon_value_type: formData.valueType, offer_active: formData.dateStart, offer_expire: formData.dateEnd,},};
    
    const apiResult = await callPostApi("cashi-offer", payload);
    if (apiResult.status === "200" && apiResult.data) {
         toast.success(apiResult.data);
         setOpend(true);
         const firstOffer = Array.isArray(apiResult.data) ? apiResult.data[0] : apiResult.data;
         const id = firstOffer.offer_id || null;
         setOfferId(id);
     } else {
       toast.error(apiResult.status_message || "Something went wrong.");
       setLoading(false);
      }
   } catch (error) { toast.error("Something went wrong. Please try again.");}
     finally { setLoading(false); }};

  const handleImageChange = async (e) => { const { files } = e.target; const file = files[0];
   try {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    } catch (err) { }
  };

  //Base 64 conversion
  const compressAndConvertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // Calculate new dimensions while maintaining aspect ratio
        let width = img.width;
        let height = img.height;
        const maxSize = 800; // Max width/height
        
        if (width > height && width > maxSize) {
          height = (height * maxSize) / width;
          width = maxSize;
        } else if (height > maxSize) {
          width = (width * maxSize) / height;
          height = maxSize;
        }
        
        canvas.width = width;
        canvas.height = height;
        
        // Draw image on canvas with new dimensions
        ctx.drawImage(img, 0, 0, width, height);
        
        // Get compressed base64 string
        const compressedBase64 = canvas.toDataURL('image/jpeg', 0.6); // Adjust quality (0-1)
        
        // Remove data:image/jpeg;base64, prefix
        const base64Data = compressedBase64.split(',')[1];
        
        // Check file size (base64 string length * 0.75 gives approximate file size in bytes)
        const approximateFileSize = Math.round((base64Data.length * 0.75) / 1024); // in KB
        
        if (approximateFileSize > 500) {
          reject(new Error('Compressed image is still larger than 500KB'));
          return;
        }
        
        resolve(base64Data);
      };
      
      img.onerror = (error) => reject(error);
    };
    
    reader.onerror = (error) => reject(error);
  });
};

  //Image upload API call
  const handleImageSave= async () => {
      if (!imageFile) {
     setErrors(prev => ({ ...prev, imageFile: 'Please select the image' }));
     toast.error('Please select the image');
     return;
   }
   try {
        const base64Data = await compressAndConvertToBase64(imageFile);
        setLoading(true);
        const payload = { mod: "UPDATE_CASHI_OFFER_IMAGE", data_arr: { store_id, offer_id:offerId,
                          offerImage : { file_name:imageFile.name, file_data:base64Data } },};
        const apiResult = await callShopviewPostApi("cashi-offer", payload);
         if (apiResult.status === "200" && apiResult.data ){
           toast.success("Coupon created successfully!");
           refreshPage();
           setOpend(false);
           navigate('/couponlist')
         } else { }
          } catch (err) { } 
          finally { setLoading(false);}
        }; 
     
  //Refresh wallet API    
  const refreshPage = async () => 
  {
      try 
      {
        const payload = { mod: "STORE_DETAIL", data_arr: { store_id,},};
        const apiResult = await callPostApi("store-login", payload);
        if (apiResult.status === "200" && apiResult.data) 
        {
            setLoginData(prev => 
            {
                const updated = {...prev, store_info: apiResult.data.store_info };
                sessionStorage.setItem('loginData', JSON.stringify(updated));
                return updated;
            });
            window.dispatchEvent(new Event('refreshNavbar')); 
        } 
        else 
        { 
            if (apiResult.status === "401") { } 
            else { }
        }
      } catch (error) { }
    };

  return (
    <Container sx={{ my: 6 }}>

      {loading && <GradientLoader text="Creating Coupon" />}        {/* // loader */}

      <Box sx={{ display: 'flex', justifyContent: 'start', mb: 2 }}>
        <Button variant="contained"  sx={{ backgroundColor: '#000000', color: '#ffffff'}} onClick={() => navigate(-1)} >
          Back </Button>
      </Box>

      <Typography variant="h6" gutterBottom sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)',  p: 1,  color: '#fff',
          borderRadius: '4px', mb: 3 }} > <Add /> Create Coupon </Typography>
           
      <Grid container spacing={2}>
        <Grid item  size={{ xs: 12,sm:12, md: 12,}} sx={{ display: 'flex' }}>
          <TextField fullWidth label="Coupon Title" value={formData.offerTitle} onChange={(e) => updateField('offerTitle', e.target.value)}
            autoFocus error={!!errors.offerTitle} helperText={errors.offerTitle}  inputprops={{ tabIndex: 1 }} />
          <InfoPopover triggerTabIndex={-1}  title="Coupon Title" description="Choose a name for your coupon. 
             This name will be visible to customers and can also be used to filter and track issued and redeemed coupons."  />
        </Grid>

        {/* Min & Max Amount */}
        <Grid item  size={{ xs: 12,sm:12, md: 6,  }} sx={{ display: 'flex' }}>
          <TextField fullWidth label="Minimum Order Value for in store distribution" type="number" value={formData.minAmount} error={!!errors.minAmount} 
          helperText={errors.minAmount} onChange={(e) => updateField('minAmount', e.target.value)}  inputprops= {{ tabIndex: 2 }}  />
          <InfoPopover triggerTabIndex={-1} title="Minimum Order Amount"  description=" Set the minimum order value needed to activate a 
          coupon for your store. This helps create customer segments based on their purchasing behavior compared to other stores. The default minimum value is set to 100, but it can be adjusted—raising it will decrease the chances of your coupons being distributed in your store." />
        </Grid>

        <Grid item  size={{ xs: 12,sm:12, md: 6,  }} sx={{ display: 'flex' }}>
          <TextField fullWidth label="Number of Coupon" type="number" value={formData.maxAmount} error={!!errors.maxAmount}
           helperText={errors.maxAmount}  onChange={(e) => updateField('maxAmount', e.target.value)} inputprops= {{ tabIndex: 3 }} />
         <InfoPopover triggerTabIndex={-1}   title="Number of Coupon" 
          description=" Enter the number of coupons you wish to generate. Only the specified number of coupons will be issued to
           prospective customers." />
        </Grid>

        {/* Value Type + Value */}
        <Grid item  size={{ xs: 12,sm:12, md: 12,  }}>
          <FormControl  inputprops={{ tabIndex: 4 }}  > <FormLabel>Coupon Value Type</FormLabel>
            <RadioGroup row value={formData.valueType} onChange={(e) => updateField('valueType', e.target.value)} >
              <FormControlLabel value="fixed" control={<Radio />} label="Fixed ₹" />
              <FormControlLabel value="percentage" control={<Radio />} label="Percentage %" />
            </RadioGroup>
          </FormControl>
          <Box sx={{ display: 'flex' }}>
           <TextField fullWidth inputprops={{ tabIndex: 5 }} label="Coupon Value" value={formData.couponValue}
            onChange={(e) => updateField('couponValue', e.target.value)} error={!!errors.couponValue}  helperText={errors.couponValue} />
           <InfoPopover triggerTabIndex={-1}  title="Coupon Value" description="Set the value of the coupon you wish to offer. You can choose a fixed amount 
            or a percentage off the total cart value (total shopping)." />
          </Box>
        </Grid>

        {/* Short Description */}
        <Grid item  size={{ xs: 12,sm:12, md: 12,  }}  sx={{ display: 'flex' }}>
          <TextField fullWidth
            inputprops={{  tabIndex: 6 }} label="Short Description *"
            value={formData.shortDesc} onChange={(e) => updateField('shortDesc', e.target.value)}
            error={!!errors.shortDesc} helperText={errors.shortDesc} />
          <InfoPopover triggerTabIndex={-1}  title="Short Description" 
             description="Write a brief description of the coupon. This will be visible to customers when they view the coupon details." />
        </Grid>

        {/* Long Description */}
        <Grid item  size={{ xs: 12,sm:12, md: 12,  }}  sx={{ display: 'flex' }}>
          <TextField fullWidth inputprops={{tabIndex: 7 }} label="Long Description *"
            multiline minRows={5} value={formData.longDesc} onChange={(e) => updateField('longDesc', e.target.value)}
            error={!!errors.longDesc} helperText={errors.longDesc} />
         <InfoPopover triggerTabIndex={-1}  title="Long Description"  description="Provide a detailed description of the coupon. This 
           information will help customers understand the benefits and terms of the coupon." />
        </Grid>

        {/* Sliders */}
        <Grid item  size={{ xs: 12,sm:12, md: 6,  }} sx={{px:1}}>
          <Typography variant="subtitle1" sx={{ mb: 1, display:'flex', alignItems:'center' }}> Distribution Bid 
          <InfoPopover triggerTabIndex={-1}  title="Distribution Bid "  description="Set the amount required to generate and distribute the coupon to
           prospective customers. This is the cost per coupon issued. A higher bid increases the likelihood of coupon distribution." />
          </Typography>
          <Slider inputprops={{ tabIndex: 8 } } min={5} max={30} defaultValue={5} step={1}
            marks={marks} value={distributionBid} onChange={(e, val) => setDistributionBid(val)}
            valueLabelDisplay="auto" />
            {errors.distributionBid && <Typography color="error">{errors.distributionBid}</Typography>}
        </Grid>

        <Grid item  size={{ xs: 12,sm:12, md: 6,  }} sx={{px:1}}>
          {/* <Typography variant="subtitle1"  sx={{ mb: 1, display:'flex', alignItems:'center' }}> Redemption value 
            <InfoPopover triggerTabIndex={-1}  title="Redemption value" description="This is the amount that CASHI will charge when the customer redeems 
               the coupon at your store. A higher redemption value increases the likelihood of redemption,
               as the system will promote it to customers more actively" />
          </Typography>
          <Slider inputprops={{ tabIndex: 9 }} min={15} max={50} defaultValue={15}
            step={1} marks={marks1} value={redemptionBid} onChange={(e, val) => setRedemptionBid(val)}
            valueLabelDisplay="auto" />
            {errors.redemptionBid && <Typography color="error">{errors.redemptionBid}</Typography>} */}
          </Grid>
        
        {/* Dates */}
        {/* Active Date */}
          <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
            <TextField fullWidth type="date" label="Active Date" inputlabelprops={{ shrink: true }} value={formData.dateStart}
              helperText={errors.dateStart} error={!!errors.dateStart} inputRef={inputRef}
               onChange={(e) => updateField("dateStart", e.target.value)} 
              inputProps={{ min: formData.dateStart || formattedToday, tabIndex: 11 }}
               onClick={() => inputRef.current?.showPicker?.()} />
          </Grid>
          
          {/* Expiry Date */}
          <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
            <TextField fullWidth type="date" label="Expiry Date" inputlabelprops={{ shrink: true }} value={formData.dateEnd}
              error={!!errors.dateEnd} helperText={errors.dateEnd} inputprops={{ inputprops: { min: formData.dateStart || formattedToday },}}
              onChange={(e) => updateField("dateEnd", e.target.value)} 
              onClick={() => inputRef1.current?.showPicker?.()} inputRef={inputRef1}  />
          </Grid>

      </Grid>

      {/* Buttons */}
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Button variant="contained" sx={{ mx: 1 }} onClick={handleSubmit} > Submit </Button> </Box>
         <DialogBox open={opend}  title="Coupon has been created, Now upload image !">
            <Box item size={{ xs: 12,sm:12, md: 6,  }}>
              <Typography  sx={{display:'flex', alignItems:'center'}}> Offer Artwork 
                <InfoPopover   title="Offer Artwork "  description="This image will be displayed on the Cashi App. For optimal resolution,
                 use a 1x1 aspect ratio in PNG format"  />
              </Typography>
              <Button variant="outlined" component="label"> {imageFile ? imageFile.name : "Upload Image"}
                  <input type="file" accept="image/*" hidden  onChange={handleImageChange} />
              </Button>
                          
              {imagePreview && <Box sx={{ mt: 2 }}><img src={imagePreview} alt="Preview" 
               style={{ width: "100%", maxHeight: "200px", objectFit: "contain", border: "1px solid #ccc",borderRadius: "8px" }} />
              </Box>}
            </Box>
            <DialogActions> <Button onClick={() => handleImageSave()}  variant="contained">Save</Button> </DialogActions>
         </DialogBox>
   
    </Container>
  );
}
